<div class="prompt-library-container">
  <div class="prompt-library-title">
    <h4>Automation Library</h4>
    <button matIconButton type="button" #tooltip="matTooltip"
      aria-label="How to use the Automation Library" [matTooltip]="tooltipText"
      matTooltipPosition="below">
      <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true" fontIcon="info" />
    </button>
  </div>

  <!-- Search bar -->
  <div class="prompt-library-search-input">
    <mat-form-field class="prompt-library-search-input-field">
      <mat-label>Search</mat-label>
      <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="filterPrompts()"
        placeholder="Search by name or description">
        @if (searchTerm) {
          <button matIconButton type="button" matSuffix aria-label="Clear search" (click)="clearSearch()">
            <mat-icon class="material-symbols-outlined icon-sm icon-action">close</mat-icon>
          </button>
        }
      </mat-form-field>
    </div>
  </div>

  <!-- Material Angular Expansion Panel -->
  <mat-accordion multi>
    <!-- Instructions Panel -->
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Prompts and Instructions</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="prompt-list-container">
        <app-prompt-library-list [data]="instructions()" [title]="'Prompts and Instructions'" [isAutomationDisabled]="isAutomationActive()"></app-prompt-library-list>
      </div>
    </mat-expansion-panel>

    <!-- Workflows Panel -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Workflows</mat-panel-title>
      </mat-expansion-panel-header>
      <div class="prompt-list-container">
        <app-prompt-library-list [data]="workflows()" [title]="'Workflows'" [isAutomationDisabled]="isAutomationActive()"></app-prompt-library-list>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
